import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
	image: {
		height: theme.spacing(20),
		width: theme.spacing(20),
	},
	content: {
		maxWidth: theme.spacing(68.75),
	},
	root: {},
}))

export default useStyles
